// @flow
/* eslint-disable max-len,react/require-default-props */

import * as React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    first: {
        fill: '#f0f1f2',
    },
    second: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 2,
    },
    third: {
        fill: 'none',
        stroke: '#0080b4',
        strokeLinecap: 'round',
        strokeMiterlimit: 10,
        strokeWidth: 2,
    },
};

const xml = `
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 149 96.5"
        width={120}
        height={120}
    >
     <title>addDevice</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2"
      data-name="Layer 1"><path d="M121.5,94.5a2,2,0,0,1-2,2h-90a2,2,0,0,1,0-4h90A2,2,0,0,1,121.5,94.5Z"
       style="fill:#f0f1f2"/><rect width="149" height="87" rx="18" style="fill:#f0f1f2"/>
       <line x1="74.5" y1="24.5" x2="74.5" y2="62.5" style="fill:none;stroke:#0080b4;
       stroke-linecap:round;stroke-linejoin:round;stroke-width:2px"/>
       <line x1="55.5" y1="43.5" x2="93.5" y2="43.5" style="fill:none;stroke:#0080b4;
       stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px"/></g></g></svg>
`;

const AddDeviceIcon = () => (
    Platform.OS === 'web' ? (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 149 96.5"
            width={120}
            height={120}
        >
            <title>addDevice</title>
            <g id="Layer_2" data-name="Layer 2">
                <g
                    id="Layer_1-2"
                    data-name="Layer 1"
                >
                    <path
                        d="M121.5,94.5a2,2,0,0,1-2,2h-90a2,2,0,0,1,0-4h90A2,2,0,0,1,121.5,94.5Z"
                        style={styles.first}
                    />
                    <rect width="149" height="87" rx="18" style={styles.first} />
                    <line
                        x1="74.5"
                        y1="24.5"
                        x2="74.5"
                        y2="62.5"
                        style={styles.second}
                    />
                    <line
                        x1="55.5"
                        y1="43.5"
                        x2="93.5"
                        y2="43.5"
                        style={styles.third}
                    />
                </g>
            </g>
        </svg>
    ) : (<SvgXml xml={xml} />)
);

export default AddDeviceIcon;
